import Navbar from "@/components/home/Navbar";
import Footer from "@/components/home/Footer";

const sections = [
    {
        title: "Préambule",
        body: [
            "La Petite Lunetterie attache une grande importance au respect de votre vie privée. La présente politique de confidentialité décrit la manière dont nous collectons, utilisons et protégeons les informations vous concernant lorsque vous visitez notre site lapetitelunetterie.fr.",
        ],
    },
    {
        title: "Données collectées",
        body: [
            "Nous ne collectons aucune donnée personnelle sans votre consentement explicite.",
            "Lorsque vous nous contactez via email, téléphone ou un formulaire, nous collectons uniquement les informations que vous nous transmettez volontairement (nom, prénom, coordonnées, message).",
            "Aucune information bancaire ni de paiement n'est traitée par le site.",
        ],
    },
    {
        title: "Utilisation des données",
        body: [
            "Les informations recueillies servent exclusivement à répondre à vos demandes et à assurer le suivi de notre relation commerciale.",
            "Elles ne sont jamais revendues, partagées ou transmises à des tiers à des fins commerciales.",
        ],
    },
    {
        title: "Cookies",
        body: [
            "Ce site n'utilise pas de cookies de suivi publicitaire.",
            "Des cookies techniques strictement nécessaires au bon fonctionnement du site peuvent être déposés (préférences d'affichage, langue).",
            "Si nous mettons en place des outils de mesure d'audience, vous serez préalablement informés et pourrez vous y opposer.",
        ],
    },
    {
        title: "Durée de conservation",
        body: [
            "Les données collectées sont conservées pendant la durée strictement nécessaire à la gestion de votre demande ou de votre relation client, puis archivées ou supprimées conformément à la réglementation en vigueur.",
        ],
    },
    {
        title: "Vos droits",
        body: [
            "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants sur vos données personnelles : droit d'accès, de rectification, d'effacement, de limitation du traitement, d'opposition et de portabilité.",
            "Pour exercer ces droits, vous pouvez nous contacter à l'adresse contact@lapetitelunetterie.fr ou par courrier au 7 place Edgar Quinet, 01000 Bourg-en-Bresse.",
            "Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (cnil.fr).",
        ],
    },
    {
        title: "Sécurité",
        body: [
            "Nous mettons en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos données contre la perte, l'utilisation abusive et l'accès non autorisé.",
        ],
    },
    {
        title: "Modification de cette politique",
        body: [
            "Cette politique de confidentialité peut être mise à jour à tout moment. La date de dernière mise à jour est précisée en bas de cette page.",
        ],
    },
];

export default function PolitiqueConfidentialite() {
    return (
        <div
            className="min-h-screen font-body bg-lpl-bg text-lpl-text"
            data-testid="confidentialite-page"
        >
            <Navbar />
            <main className="pt-24 md:pt-28 pb-20">
                <section className="max-w-3xl mx-auto px-5 md:px-10 py-12">
                    <p className="font-serif italic text-2xl md:text-3xl text-lpl-terracotta mb-4">
                        Vos données, votre tranquillité
                    </p>
                    <h1
                        className="font-display font-semibold text-5xl md:text-7xl text-lpl-text leading-[0.95] tracking-tight mb-12"
                        data-testid="confidentialite-title"
                    >
                        Politique de{" "}
                        <span className="font-serif italic font-normal text-lpl-primary-deep">
                            confidentialité
                        </span>
                        <span className="font-serif italic font-normal text-lpl-lavender">
                            .
                        </span>
                    </h1>

                    <div className="space-y-12">
                        {sections.map((s) => (
                            <article key={s.title}>
                                <h2 className="font-display font-semibold text-2xl md:text-3xl text-lpl-text leading-tight tracking-tight mb-4">
                                    {s.title}
                                </h2>
                                <div className="space-y-3 text-lpl-text-muted text-base md:text-lg leading-relaxed">
                                    {s.body.map((p, i) => (
                                        <p key={i}>{p}</p>
                                    ))}
                                </div>
                            </article>
                        ))}
                    </div>

                    <p className="mt-16 text-xs uppercase tracking-[0.18em] text-lpl-text-muted">
                        Dernière mise à jour : février 2026
                    </p>
                </section>
            </main>
            <Footer />
        </div>
    );
}
